import { getData, postData } from '@core/utils/http/general'

//* Get person's id
export const getPersonId = (id, time) => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 23,
    id,
    time,
  }
  getData(paramsRequest)
    .then(response => {
      if (response.status === 200) resolve(response.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

//* Send mail to upload documentation later
export const sendLaterMail = (id, time) => new Promise((resolve, reject) => {
  const data = new FormData()
  data.append('task', 'wspublico')
  data.append('origin', process.env.VUE_APP_ORIGIN_API)
  data.append('action', 24)
  data.append('time', time)
  data.append('id', id)

  postData(data)
    .then(response => {
      if (response.status === 200 && response.data.status === 200) resolve(response.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
